import { Builder } from '@builder.io/react';

import LogoGridUI from './index';

Builder.registerComponent(LogoGridUI, {
  name: "LogoGridUI",
  inputs: [
    {
      name: 'text',
      type: 'string',
      defaultValue: 'Trusted by the world’s most ambitious AI teams.'
    },
    {
      name: 'customers',
      type: 'list',
      defaultValue: [
        {
          url: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F8eac1a4bb08044fbaf98b047fcd07dd1'
        }
      ],
      subFields: [
        {
          name: 'url',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg'],
          defaultValue: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F8eac1a4bb08044fbaf98b047fcd07dd1',
          helperText: 'Only SVG images'
        },
        {
          name: 'alt',
          type: 'string'
        }
      ]
    }
  ]
});